import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { TRLogo } from 'builder/components/Icon/20x20'

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 80px);

  ${Media.Phone`
    height: calc(100vh - 150px);
  `};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 64px;
  gap: 32px;
  width: 100%;
  overflow: auto;

  ${Media.Phone`
    gap: 24px;
    padding: 20px;
    padding-bottom: 0;
  `};
`

export const BoxWrapper = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;

  ${Media.Phone`
    flex-direction: column;
    align-items: center;
    gap: 20px;
  `};
`

export const Box = styled.div<{ $isError?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  position: relative;
  max-width: 448px;
  min-height: 384px;

  border: 1px solid ${({ $isError }) => ($isError ? Colors.Red50 : Colors.Neutral15)};
  border-radius: 16px;
  gap: 12px;
  cursor: pointer;

  ${Media.Tablet`
    max-width: 448px;
    height: unset;
  `}

  ${Media.Phone`
    width: 100%;
    height: unset;
    min-height: 234px;
  `}

  &:hover {
    box-shadow: 0px 16px 64px -8px rgba(15, 56, 113, 0.18), 0px 6px 8px -2px rgba(15, 56, 113, 0.02),
      0px 0px 1px 0px rgba(15, 56, 113, 0.32);
    transition: box-shadow 0.2s ease-in;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const Image = styled.div<{ $image: string }>`
  width: 100%;
  height: 228px;
  background-image: ${({ $image }) => `url(${$image})`};
  background-size: cover;
  background-position: center;

  ${Media.Phone`
    height: 100px;
    background-size: contain;
  `}
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 8px;
  padding: 0 32px 32px;

  ${Media.Phone`
    padding: 0 24px 24px;
  `}
`

export const Header = styled.h2<{ $isTrCard?: boolean }>`
  ${Typography.S}
  ${FontWeights.Medium}

  text-align: center;
  color: ${Colors.Neutral90};
  max-width: ${({ $isTrCard }) => ($isTrCard ? '385px' : '250px')};
`

export const Description = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  max-width: 250px;
  text-align: center;
  color: ${Colors.Neutral50};
`

export const UploadFromDevice = styled.label`
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
`

export const TrResumeLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: ${Colors.Neutral5};
  border: 1px solid ${Colors.Blue40};
  padding: 8px;
  border-radius: 8px;

  ${Media.Phone`
    padding: 7px 8px;
  `}
`

export const TrResumeLabelIcon = styled(TRLogo)``
export const TrResumeLabelText = styled.div`
  ${Typography.Caption}
  ${FontWeights.Regular}
`

export const ErrorContainer = styled.div`
  height: 40px;
  bottom: -52px;
  position: absolute;
  display: flex;

  ${Media.Phone`
    bottom: -50px;
  `}
`

export const ErrorLabel = styled.p`
  ${Typography.Caption}
  ${FontWeights.Regular}

  text-align: center;
  color: ${Colors.Red50};
`
